import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-live-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                K-Stream 解析
              </span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed mb-5">
              深度解析韩国女主播的直播风格、内容特色与粉丝运营技巧，为你揭开韩国直播文化的魅力面纱。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="YouTube">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline">
                  服务条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/korean-streamer-aegyo-culture-analysis" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline line-clamp-1">
                  撒娇文化全方位解析
                </Link>
              </li>
              <li>
                <Link to="/article/afreecatv-vs-twitch-korean-streamer-platform" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline line-clamp-1">
                  AfreecaTV vs Twitch对比
                </Link>
              </li>
              <li>
                <Link to="/article/top-10-korean-streamers-2026" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline line-clamp-1">
                  2026年TOP10推荐
                </Link>
              </li>
              <li>
                <Link to="/article/korean-streamer-monetization-models" className="text-background-50/60 text-sm hover:text-primary-400 transition-colors no-underline line-clamp-1">
                  多元变现模式拆解
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} K-Stream 解析. All rights reserved.
          </p>
          <p className="text-background-50/40 text-xs">
            深度解析韩国女主播的直播风格与魅力
          </p>
        </div>
      </div>
    </footer>
  );
}